import { Controller } from "@hotwired/stimulus"

/**
 * Shorts Wizard Controller
 * Handles navigation and state management for the wizard flow
 */
export default class extends Controller {
  static values = {
    configId: Number
  }

  static targets = ["stepContent"]

  connect() {
    // Initialize wizard state
    this.currentStep = this.getCurrentStepFromUrl()
  }

  getCurrentStepFromUrl() {
    const path = window.location.pathname
    if (path.includes("wizard_script")) return "script"
    if (path.includes("wizard_style")) return "style"
    if (path.includes("wizard_generate")) return "generate"
    if (path.includes("wizard_preview")) return "preview"
    return "script"
  }
}
